module.exports = __webpack_public_path__ + "static/media/icon-happiness-light.d20671be.svg";